<div class="additional-visitor">
    <sc-padding>
        <sc-flex vertical fitHeight stretchContent>

            <div>
                <ng-container [formGroup]="masterdataForm">
                    <sc-flex>
                        <mat-form-field appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.name"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="name" formControlName="name"
                                [required]="true" minlength="row.minLength" maxlength="255">
                        </mat-form-field>
                        <sc-content-spacer [double]="true"></sc-content-spacer>
                        <mat-form-field appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.firstname"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="firstname" formControlName="firstname"
                                [required]="true" minlength="row.minLength" maxlength="255">
                        </mat-form-field>
                        <sc-content-spacer [double]="true"></sc-content-spacer>
                        <mat-form-field class="mail-field" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.mail"></sc-dictionary-label>
                          </mat-label>
                            <input matInput name="mail" formControlName="mail"
                                [required]="true" minlength="row.minLength" maxlength="255">
                        </mat-form-field>
                        <sc-content-spacer [double]="true"></sc-content-spacer>
                        <button mat-flat-button (click)="inviteAdditionalVisitor()" [disabled]="!masterdataForm.valid">
                          <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-additional-visitors.button.add"></sc-dictionary-label>
                        </button>
                    </sc-flex>
                </ng-container>
            </div>

            <sc-content-spacer vertical [double]="true"></sc-content-spacer>

            <b>
              <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.visitor-additional-visitors.label.already-invited"></sc-dictionary-label>
            </b>
            <sc-content-spacer vertical></sc-content-spacer>
            <table>
                <thead>
                    <tr>
                    <td class="name">
                      <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.name"></sc-dictionary-label>
                    </td>
                    <td class="firstname">
                      <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.firstname"></sc-dictionary-label>
                    </td>
                    <td class="mail">
                      <sc-dictionary-label dictionaryKey="tmc-yard.entity.visit.mail"></sc-dictionary-label>
                    </td>
                    <td class="registrationCode">
                      <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.registrationCode"></sc-dictionary-label>
                    </td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entry of additionalVisitors">
                        <td class="name text-selection">{{entry.name}}</td>
                        <td class="firstname text-selection">{{entry.firstname}}</td>
                        <td class="mail text-selection">{{entry.mail}}</td>
                        <td class="registrationCode text-selection">{{entry.registrationCode}}</td>
                    </tr>
                </tbody>
            </table>

            <sc-content-spacer vertical grow></sc-content-spacer>

        </sc-flex>
    </sc-padding>
</div>
